import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner} from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Link } from 'react-router-dom';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4"
import backgroundImageFile from '../../images/ClientPortalBG.jpg'; // Adjust relative path based on where LoginForm is inside components/


class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            value: '',
            loading: false,
            error: null,
            userID: props.location.search == ''  ? '' :  props.location.search.split('&')[0].split('=')[1],
            userEmail: props.location.search == '' ? '' : props.location.search.split('&')[1].split('=')[1],
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.showButton = this.showButton.bind(this);
        //this.setMSSOCookie = this.setMSSOCookie.bind(this);
    }
    componentDidMount() {
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    handlePasswordChange(event) {
        this.setState({ password: event.target.value });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true });
        axios.post(`${Constants.apiURL}/api/Identity/Login`, {
            email: this.state.email,
            password: this.state.password
        }).then(response => {
            if (response.data && response.data.message) {
                if (response.data.message.succeeded == true) {
                    this.props.history.push({
                        pathname: '/landing_page',
                        state: {
                            user: response.data.user
                        }
                    });
                    ReactGA.set({ userId: response.data.user.username });
                    ReactGA.event({
                        category: 'Login',
                        action: 'Login',
                        label: 'Login'
                    });
                }
                else {
                    this.setState({ error: 'Invalid email or password' });
                }
            }
            else {
                this.setState({ error: 'Invalid email or password' });
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ error: `${Constants.apiURL}/api/Identity/Login,  Error connecting to server.` })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <div>
                <Button style={{ marginTop: '5px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" type="submit" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true" />
                    <span className="visually-hidden">Loading...</span>
                </Button>
                <br />
                <p style={{ fontSize: '14px', paddingTop: '5px', marginBottom: '0px' }}>Trouble logging in? Contact us at&nbsp;
                    <Link
                        to='#'
                        onClick={(e) => {
                            window.location.href = 'mailto:clientportal@boland.com';
                            e.preventDefault();
                        }}
                    >clientportal@boland.com</Link></p>
                <Link to={{
                    pathname: "/forgot_password"
                }} style={{ marginTop: '0px' }}>Forgot password?</Link>
                <p style={{ fontSize: '14px', paddingTop: '10px' }}>Don’t have a portal account yet? Click below to register.</p>
                <Button style={{ marginTop: '-10px', width: '80px', backgroundColor: '#00973A' }} type="button" onClick={this.handleRegister}>
                        Register
             </Button></div>
        }
        else {
            return <div><Button style={{ marginTop: '10px', backgroundColor: '#1F419B', width: '80px' }} variant="primary" type="submit">
                Login
            </Button>
                <br />
                <p style={{ fontSize: '14px', paddingTop: '5px', marginBottom: '0px' }}>Trouble logging in? Contact us at&nbsp;
                    <Link
                        to='#'
                        onClick={(e) => {
                            window.location.href = 'mailto:clientportal@boland.com';
                            e.preventDefault();
                        }}
                    >clientportal@boland.com</Link></p>
                <Link to={{
                    pathname: "/forgot_password"
                }} style={{ marginTop: '0px' }}>Forgot password?</Link>
                <p style={{ fontSize: '14px', paddingTop: '10px' }}>Don’t have a portal account yet? Click below to register.</p>
                <Button style={{ marginTop: '-10px', width: '80px', backgroundColor: '#00973A' }} type="button" onClick={this.handleRegister}>
                    Register
                </Button></div>
        }
    }

    handleRegister(event) {
        event.preventDefault();
        this.props.history.push({
            pathname: '/register'
        });
    }

    render() {
        const backgroundStyle = {
            // Replace with the actual path to your image
            backgroundImage: `url(${backgroundImageFile})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        };

        const customStyle = {
            padding: '20px',
            // Changed 'auto' to specific margins to give it breathing room from the edges
            marginTop: '40px',
            marginLeft: '40px',
            marginRight: '20px',
            marginBottom: '20px',
            maxWidth: '480px',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        };

        return (
            <div style={backgroundStyle}>
                <GuestSiteMenu currentPage='login' />

                {/* Changed classes to align items to the start (top-left) instead of center */}
                <div className="flex-grow-1 d-flex align-items-start justify-content-start">
                    <Form style={customStyle} onSubmit={this.handleSubmit} noValidate>
                        <Form.Label style={{ verticalAlign: 'middle', fontWeight: 'bold', fontSize: '26px', color: '#1F419B' }}>Portal Login</Form.Label>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control type="email" placeholder="Enter email" onChange={this.handleEmailChange}
                                        isInvalid={!!this.state.error} />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control type="password" placeholder="Password" onChange={this.handlePasswordChange}
                                        isInvalid={!!this.state.error} />
                                    <Form.Control.Feedback type='invalid'>
                                        {this.state.error}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                {this.showButton()}
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        );
    }


    //render() {
    //    const backgroundStyle = {
    //        // Replace with the actual path to your image
    //        backgroundImage: `url(${backgroundImageFile})`,
    //        backgroundPosition: 'center',
    //        backgroundSize: 'cover',
    //        backgroundRepeat: 'no-repeat',
    //        minHeight: '100vh', // Ensures it takes up the full height of the viewport
    //        width: '100%',
    //        display: 'flex',
    //        flexDirection: 'column'
    //    };

    //    const customStyle = {
    //        padding: '20px',
    //        margin: 'auto', // Centers the form horizontally and vertically if using flex
    //        maxWidth: '480px',
    //        backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slightly transparent white so the form stands out
    //        borderRadius: '8px',
    //        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    //    };

    //    return (
    //        <div style={backgroundStyle}>
    //            <GuestSiteMenu currentPage='login' />

    //            {/* Centering container for the form */}
    //            <div className="flex-grow-1 d-flex align-items-center justify-content-center">
    //                <Form style={customStyle} onSubmit={this.handleSubmit} noValidate>
    //                    <Form.Label style={{ verticalAlign: 'middle', fontWeight: 'bold', fontSize: '26px', color: '#1F419B' }}>Portal Login</Form.Label>
    //                    <Row>
    //                        <Col>
    //                            <Form.Group className="mb-3" controlId="formBasicEmail">
    //                                <Form.Label>Email address</Form.Label>
    //                                <Form.Control type="email" placeholder="Enter email" onChange={this.handleEmailChange}
    //                                    isInvalid={!!this.state.error} />
    //                            </Form.Group>

    //                            <Form.Group className="mb-3" controlId="formBasicPassword">
    //                                <Form.Label>Password</Form.Label>
    //                                <Form.Control type="password" placeholder="Password" onChange={this.handlePasswordChange}
    //                                    isInvalid={!!this.state.error} />
    //                                <Form.Control.Feedback type='invalid'>
    //                                    {this.state.error}
    //                                </Form.Control.Feedback>
    //                            </Form.Group>
    //                            {this.showButton()}
    //                        </Col>
    //                    </Row>
    //                </Form>
    //            </div>
    //        </div>
    //    );
    //}

//    render() {
//        const customStyle = {
//            padding: '10px',
//            margin: '10px',
//            maxWidth: '480px'
//        };
//        return (
//            <div>
//                <GuestSiteMenu currentPage='login' />{/*
//                <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded sticky="top">
//                    <Container style={{ marginLeft: '0px' }}>
//                        <Navbar.Brand style={{ margin: 0, padding: 0, color: '#FFFFFF' }}>
//                            <Image src="./Boland block 2.png" width="165px" height="40px" />{' '}
//                        </Navbar.Brand>
//                        <Navbar.Collapse>
//                            <Navbar.Text style={{ color: '#FFFFFF', paddingLeft: '30px', fontSize: '18px' }}>
//                                Welcome to our client portal.
//                            </Navbar.Text>
//                        </Navbar.Collapse>
//                    </Container>
//                </Navbar>*/}
//                <Form style={customStyle} onSubmit={this.handleSubmit} noValidate>
//                    <Form.Label style={{ verticalAlign: 'middle', fontWeight: 'bold', fontSize: '26px', color: '#1F419B' }}>Portal Login</Form.Label>
//                    <Row>
//                        <Col>
//                            <Form.Group className="mb-3" controlId="formBasicEmail">
//                                <Form.Label>Email address</Form.Label>
//                                <Form.Control type="email" placeholder="Enter email" onChange={this.handleEmailChange}
//                                    isInvalid={!!this.state.error} />
//                            </Form.Group>

//                            <Form.Group className="mb-3" controlId="formBasicPassword">
//                                <Form.Label>Password</Form.Label>
//                                <Form.Control type="password" placeholder="Password" onChange={this.handlePasswordChange}
//                                    isInvalid={!!this.state.error} />
//                                <Form.Control.Feedback type='invalid'>
//                                    {this.state.error}
//                                </Form.Control.Feedback>
//                            </Form.Group>
//                            {this.showButton()}
//                        </Col>
//                    {/*    <Col>*/}
//                    {/*        <a href={`${Constants.secURL}/home/Signin`} >*/}
//                    {/*            <Image src="./SignInWithMicrosoft.jpg" width="240" height="40" />*/}
//                    {/*        </a>*/}
//                    {/*    </Col>*/}
//                    </Row>
//                </Form>
//            </div>
//        );
//    }
}

export default LoginForm;